export default "__VITE_ASSET__Cfk9G4sE__"